import { type FC } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

import { type PimProductV11 } from '@redteclab/api/clients/bully'

import { priceGetFormattedPrice } from '../../../price/priceGetFormattedPrice'
import { useProductPrices } from '../../../product-page/components/ProductBuyBox/hooks/useProductPrices'
import { useProductPageContext } from '../../../product-page/components/productPageContext'
import { ProductPicture } from '../../../product/components/ProductPicture'

import { ExperimentStickyBuyBoxCta } from './ExperimentStickyBuyBoxCta'

export const ExperimentStickyBuyBoxV2Mobile: FC<{
  disableCta: boolean
  product: PimProductV11
}> = ({ disableCta, product }) => {
  const { currentPrescriptionType, offerId } = useProductPageContext()
  const { displayPrice } = useProductPrices({
    currentPrescriptionType,
    offerId,
    product,
  })
  const intl = useIntl()

  return (
    <ul className="fixed inset-x-0 bottom-0 z-10 bg-light-primary-low p-3.5 shadow-[0_6px_12px_#00000033] tablet:hidden">
      <li className="flex justify-between">
        <div className="w-[82%]">
          <h2 className="truncate text-m font-medium">{product.name}</h2>
        </div>

        <div className="flex flex-col items-start whitespace-nowrap">
          <span className="text-xs text-dark-primary-medium">
            <FormattedMessage id="general.label.yourPrice" />
          </span>
          <span className="font-bold text-dark-accent">
            {priceGetFormattedPrice(displayPrice?.price ?? 0, intl)}
          </span>
        </div>
      </li>
      <li className="flex items-center justify-between">
        <div>
          <ProductPicture
            className="shrink-0"
            imageProps={{
              alt: product.name,
              height: 55,
              src: product.images?.at(0),
              width: 55,
            }}
          />
        </div>
        <div className="grow">
          <ExperimentStickyBuyBoxCta disableCta={disableCta} />
        </div>
      </li>
    </ul>
  )
}
